const routes = {
    /* auth */
    login: () => `/login`,
    pin: () => `/pin`,
    register: () => `/register`,
    restorePassword: () => `/restore-password`,

    /* core */
    connect: () => `/connect`,
    home: () => `/home`,
    device: deviceId => `${deviceId}/profile`,
    deviceRaw: () => `:deviceId/profile`,
    cost: () => `/cost`,
    control: () => `/control`,
    alert: () => `/alert`,
    more: () => `/more`,

    /* service */
    utilitySettings: () => `/utility-settings`,
    settings: () => `/settings`,
    settingsNonAuth: () => `/settings-non-auth`,
    notFound: () => `/404`,
    codePush: () => `/code-push`,
    splash: () => `/splash`,

    // old
    addAlert: () => `/add-alert`,
    error: () => `/error`,
    demo: () => `/demo`
};

export { routes };


// WEBPACK FOOTER //
// ./~/pluton-core/lib/constants/routes.constant.js